import cn from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
var LowQualityIndicator = function LowQualityIndicator(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "low-quality-indicator",
    className: cn('w-8 h-8 rounded-full bg-yellow-main flex-shrink-0', className)
  });
};
export default LowQualityIndicator;